import { AssignGradingResponse, BillNumberRequest, CommonResponse, GradeLotInvResponse, GradeLotNoResponse, GradingDashboardResponse, GradingInventoryResponse, LotCodesResponse } from '@gtpl/shared-models/production-management';
import { PlantRequest } from '@gtpl/shared-models/raw-material-procurement';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { AssignSoDto } from './dto/assign-so.dto';
import { GradeLotNoRequest } from './dto/grade-lot-no.request';
import { GradeReportingDto } from './dto/grade-reporting.dto';
import { ProductionInventoryData } from './dto/production-inventory.dto';
import { UnitRequest } from './dto/unit.id.request';
import { GradeInventoryService } from './grade-inventory.service';
import { ProductionLogService } from './production-log.service';
import { ProductReq } from '@gtpl/shared-models/analytics-data';
import { ProductionLogRequest } from 'libs/shared-models/production-management/src/lib/production-inv/production-log.req';

@ApiTags('Grading')
@Controller('grade-inventory')
export class GradeInventoryController {
    constructor(private gradeInventoryService: GradeInventoryService,
        private logService:ProductionLogService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }
    @Post('/assignGradingOperation')
    async assignGradingOperation(@Body() inputReq: ProductionInventoryData): Promise<AssignGradingResponse> {
        try {
            return await this.gradeInventoryService.assignGradingOperation(inputReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AssignGradingResponse, error);
        }
    }

    @Post('/getLotLevelInfoForGrading')
    async getLotLevelInfoForGrading(@Body() inputReq: GradeLotNoRequest): Promise<GradeLotNoResponse> {
        try {
            return await this.gradeInventoryService.getLotLevelInfoForGrading(inputReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GradeLotNoResponse, error);
        }
    }

    @Post('/saveCountInGradeInventory')
    async saveCountInGradeInventory(@Body() inputReq: GradeReportingDto): Promise<CommonResponse> {
        try {
            return await this.gradeInventoryService.saveCountInGradeInventory(inputReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getLotLevelGradingInventory')
    async getLotLevelGradingInventory(@Body() inputReq: UnitRequest): Promise<GradeLotInvResponse> {
        try {
            return await this.gradeInventoryService.getLotLevelGradingInventory(inputReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GradeLotInvResponse, error);
        }
    }

    @Post('/assignCountToSO')
    async assignCountToSO(@Body() inputReq: AssignSoDto): Promise<CommonResponse> {
        try {
            return await this.gradeInventoryService.assignCountToSO(inputReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getGradingInventory')
    async getGradingInventory(@Body() inputReq: UnitRequest): Promise<GradingInventoryResponse> {
        try {
            return await this.gradeInventoryService.getGradingInventory(inputReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GradingInventoryResponse, error);
        }
    }

    @Post('/getGradingDashboardData')
    async getGradingDashboardData(@Body() inputReq: UnitRequest): Promise<GradingDashboardResponse> {
        try {
            return await this.gradeInventoryService.getGradingDashboardData(inputReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GradingDashboardResponse, error);
        }
    }

    @Post('/getLotNosForGrading')
    async getLotNosForGrading(@Body() inputReq: UnitRequest): Promise<LotCodesResponse> {
        try {
            return await this.gradeInventoryService.getLotNosForGrading(inputReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(LotCodesResponse, error);
        }
    }

    @Post('/getYieldReportData')
    async getYieldReportData(@Body() inputReq: UnitRequest): Promise<CommonResponse> {
        try {
            return await this.gradeInventoryService.getYieldReportData(inputReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/clearWip')
    async clearWip(@Body() inputReq:GradeLotNoRequest): Promise<CommonResponse> {
        try {
            return await this.gradeInventoryService.clearWip(inputReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/deheadingInventotyData')
    async deheadingInventotyData(@Body() inputReq:UnitRequest): Promise<CommonResponse> {
        try {
            return await this.gradeInventoryService.deheadingInventotyData(inputReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/createGradeReporting')
    async createGradeReporting(@Body() inputReq:GradeReportingDto): Promise<CommonResponse> {
        try {
            return await this.gradeInventoryService.createGradeReporting(inputReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getGradingAnalysisReport')
    async getGradingAnalysisReport(@Body() req?:ProductionLogRequest):Promise<CommonResponse>{
        try{
            return await this.gradeInventoryService.getGradingAnalysisReport(req);
      
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
    
        }
    }
    @Post('/getGradingSummaryReport')
    async getGradingSummaryReport(@Body() req?:BillNumberRequest):Promise<CommonResponse>{
        try{
            return await this.gradeInventoryService.getGradingSummaryReport(req);
      
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
    
        }
    }

    @Post('/getLotNumbersAgainistGradeRange')
    async getLogNumbersAgainistGradeRange(@Body() req?:BillNumberRequest):Promise<CommonResponse>{
        try{
            return await this.gradeInventoryService.getLotNumbersAgainistGradeRange(req);
      
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
    
        }
    }

    @Post('/updateHonInfoInGradeInv')
    async updateHonInfoInGradeInv():Promise<CommonResponse>{
        try{
            return await this.gradeInventoryService.updateHonInfoInGradeInv();
      
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
    
        }
    }

    @Post('/updateRatesAgainstIndentDate')
    async updateRatesAgainstIndentDate():Promise<CommonResponse>{
        try{
            return await this.gradeInventoryService.updateRatesAgainstIndentDate();
      
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
    
        }
    }

}
